import en from './languages/en';

export default { en };